module.exports = __webpack_public_path__ + "img/SO.e92c33bd.svg";